import React, { useEffect, useState, useRef } from "react"
import "./styles.scss"
import Article from "../../molecules/Article"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.scss"
import "./styles.scss"
const ArticlesListing = ({ articles, categories, isDesktop }) => {
  const [activeCat, setActiveCat] = useState(0)
  const [filteredArticles, setFilteredArticles] = useState(null)
  const [numOfArticlesInCat, setNumOfArticlesInCat] = useState(null)
  const [page, setPage] = useState(1)
  const articlesListingRef = useRef();
  const articlesPerPage = 8

  function filterArticles(cat, articles) {
    if (cat !== activeCat) {
      setPage(1)
      setActiveCat(cat)
    }
    if (cat === 0) {
      if (articles.length) {
        setNumOfArticlesInCat(articles.length)
      } else {
        setNumOfArticlesInCat(1)
      }
      const slicedArticles = articles.slice(
        articlesPerPage * (page - 1),
        articlesPerPage * page
      )
      setFilteredArticles(slicedArticles)

      return false
    }
    const articlesFiltered = articles.filter(
      ({ node }) => node?.category?.id === cat
    )
    if (articlesFiltered.length) {
      setNumOfArticlesInCat(articlesFiltered.length)
    } else {
      setNumOfArticlesInCat(1)
    }

    // Slice array
    const slicedArticles = articlesFiltered.slice(
      articlesPerPage * (page - 1),
      articlesPerPage * page
    )

    setFilteredArticles(slicedArticles)
  }

  const scrollToTopListing = () => {
      articlesListingRef.current.scrollIntoView();
  }

  useEffect(() => {
    filterArticles(activeCat, articles)
  }, [page])

  return (
    <section className="section section--articlesListing" >
      <div className="articlesListing__anchor" ref={articlesListingRef}></div>
      {/* {!isDesktop && (
        <div className="wrapper--text wrapper--mobile">
          <div className="articlesCategories articlesCategoriesMobile">
            <Swiper
              slidesPerView="auto"
              slidesOffsetBefore={24}
              slidesOffsetAfter={24}
            >
              <SwiperSlide>
                <div
                  onClick={() => filterArticles(0, articles)}
                  className={`category ${activeCat === 0 ? "active" : ""}`}
                >
                  All Categories
                </div>
              </SwiperSlide>
              {categories.map(({ node }, index) => {
                return (
                  <SwiperSlide key={index}>
                    <div
                      className={`category ${
                        activeCat === ++index ? "active" : ""
                      }`}
                      onClick={() => filterArticles(node.strapiId, articles)}
                    >
                      {node.Title}
                    </div>
                  </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
        </div>
      )} */}
      <div className="wrapper--text">
        {/* {isDesktop && (
          <ul className="articlesCategories">
            <li
              onClick={() => filterArticles(0, articles)}
              className={`category ${activeCat === 0 ? "active" : ""}`}
            >
              All Categories
            </li>
            {categories.map(({ node }) => {
              return (
                <li
                  onClick={() => filterArticles(node.strapiId, articles)}
                  key={node.strapiId}
                  className={`category ${
                    activeCat === node.strapiId ? "active" : ""
                  }`}
                >
                  {node.Title}
                </li>
              )
            })}
          </ul>
        )} */}

        <div className="articlesListing">
          {isDesktop && (
            <>
              {!filteredArticles?.length && (
                <p className="articlesListing__noarticles">
                  Oops! There are no articles in this category yet. Our team is
                  writing them at the moment.
                </p>
              )}

              <div className="articlesListing__column">
                {filteredArticles?.map(({ node }, index) => {
                  const slug = node.articleCustomUrl
                    ? node.articleCustomUrl
                    : node.title
                        .toLowerCase()
                        .replace(/[^\w\s]/gi, "")

                        .split(" ")
                        .slice(0, 3)
                        .join("-")
                  if (index % 2 === 0) {
                    return (
                      <Article
                        category={node.category}
                        timeToRead={node.timeToRead}
                        link={slug}
                        image={node?.image?.childImageSharp?.fluid}
                        title={node.title}
                        excerpt={node.excerpt}
                        date={node.date}
                        key={`${node.id}-${activeCat}`}
                        delay={index}
                      />
                    )
                  }
                })}
              </div>
              <div className="articlesListing__column">
                {filteredArticles?.map(({ node }, index) => {
                  const slug = node.articleCustomUrl
                    ? node.articleCustomUrl
                    : node.title
                        .toLowerCase()
                        .replace(/[^\w\s]/gi, "")
                        .split(" ")
                        .slice(0, 3)
                        .join("-")
                  if (index % 2 !== 0) {
                    return (
                      <Article
                        category={node.category}
                        timeToRead={node.timeToRead}
                        link={slug}
                        image={node?.image?.childImageSharp?.fluid}
                        title={node.title}
                        excerpt={node.excerpt}
                        date={node.date}
                        key={`${node.id}-${activeCat}`}
                        delay={index}
                      />
                    )
                  }
                })}
              </div>
            </>
          )}
          {!isDesktop && (
            <>
              {!filteredArticles?.length && (
                <p className="articlesListing__noarticles">
                  Oops! There are no articles in this category yet. Our team is
                  writing them at the moment.
                </p>
              )}

              <div className="articlesListing__column articlesListing__column--mobile">
                {filteredArticles?.map(({ node }, index) => {
                  const slug = node.articleCustomUrl
                    ? node.articleCustomUrl
                    : node.title
                        .toLowerCase()
                        .replace(/[^\w\s]/gi, "")

                        .split(" ")
                        .slice(0, 3)
                        .join("-")
                  return (
                    <Article
                      category={node.category}
                      timeToRead={node.timeToRead}
                      link={slug}
                      image={node?.image?.childImageSharp?.fluid}
                      title={node.title}
                      excerpt={node.excerpt}
                      date={node.date}
                      key={`${node.id}-${activeCat}`}
                      delay={index}
                    />
                  )
                })}
              </div>
            </>
          )}
        </div>

        <div className="articlesNavigation">
          <span
            onClick={() => {
              setPage(page - 1)
              scrollToTopListing()
            }}
            className={`btn btn--bordered ${page === 1 ? "disabled" : ""}`}
          >
            Prev
          </span>
          <span
            onClick={() => {
              setPage(page + 1)
              scrollToTopListing()
            }}
            className={`btn btn--bordered ${
              page === Math.ceil(numOfArticlesInCat / articlesPerPage)
                ? "disabled"
                : ""
            }`}
          >
            Next
          </span>
        </div>
      </div>
    </section>
  )
}

export default ArticlesListing

/* trigger */
